import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import styles from './financeOnboarding.module.scss'

// Gulir halaman di bawah penutup. Klik tetap ditahan penutupnya.
const scrollUnderLock = (lock, clientX, clientY, deltaY) => {
  if (!deltaY || !lock) {
    return
  }
  lock.classList.add(styles.maskPassthrough)
  const el = document.elementFromPoint(clientX, clientY)
  lock.classList.remove(styles.maskPassthrough)
  let node = el
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node)
    if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight) {
      node.scrollTop += deltaY
      return
    }
    node = node.parentElement
  }
  window.scrollBy(0, deltaY)
}

// Kartu melayang di kanan atas konten (helper isi form, WhatsApp terkirim).
// lock: tampilkan penutup layar yang memblokir klik di luar kartu (dipakai step WA_DONE).
// Gulungan halaman tetap diteruskan ke konten di bawahnya.
const FloatingCard = ({ children, lock = false }) => {
  const lockRef = useRef(null)

  useEffect(() => {
    const node = lockRef.current
    if (!lock || !node) {
      return undefined
    }
    const onWheel = (event) => {
      event.preventDefault()
      scrollUnderLock(node, event.clientX, event.clientY, event.deltaY)
    }
    let lastY = 0
    const onTouchStart = (event) => {
      lastY = event.touches[0]?.clientY || 0
    }
    const onTouchMove = (event) => {
      const touch = event.touches[0]
      if (!touch) {
        return
      }
      event.preventDefault()
      const delta = lastY - touch.clientY
      lastY = touch.clientY
      scrollUnderLock(node, touch.clientX, touch.clientY, delta)
    }
    node.addEventListener('wheel', onWheel, { passive: false })
    node.addEventListener('touchstart', onTouchStart, { passive: true })
    node.addEventListener('touchmove', onTouchMove, { passive: false })
    return () => {
      node.removeEventListener('wheel', onWheel)
      node.removeEventListener('touchstart', onTouchStart)
      node.removeEventListener('touchmove', onTouchMove)
    }
  }, [lock])

  return createPortal(
    <>
      {lock && <div ref={lockRef} className={styles.cardLock} aria-hidden="true" />}
      <aside className={styles.card} aria-live="polite">
        {children}
      </aside>
    </>,
    document.body,
  )
}

export default FloatingCard
